export default __webpack_public_path__ + "static/media/Discord Logo.a7364ad9.svg";